import React from "react";
import { GroupCategoryPageManager } from "../components/post";

export const GroupCategoryPages: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg">
          <div className="px-6 py-4 border-b border-gray-200">
            <h1 className="text-2xl font-bold text-gray-900">
              Grupy Kategorii
            </h1>
            <p className="mt-1 text-sm text-gray-600">
              Zarządzaj grupami kategorii i organizuj swoje kategorie w
              hierarchiczne struktury.
            </p>
          </div>
          <div className="p-6">
            <GroupCategoryPageManager />
          </div>
        </div>
      </div>
    </div>
  );
};
